if (!customElements.get("popover-component")) {
  class PopoverComponent extends HTMLElement {
    constructor() {
      super();
      this.id = this.getAttribute("id");
      this.triggerButton = document.querySelector(
        `[data-drawer-open="${this.id}"]`
      );
      this.closeButton = this.querySelector(`[data-drawer-close="${this.id}"]`);

      this.triggerButton.addEventListener("click", this.openDrawer.bind(this));
      this.closeButton.addEventListener("click", this.closeDrawer.bind(this));

      subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
        if (event.el.closest("popover-component").id !== this.id) return;

        console.log("closing popover after atc");
        this.closeDrawer();
      });
    }
    openDrawer() {
      this.classList.add("active");
    }
    closeDrawer() {
      this.classList.remove("active");
    }
  }
  customElements.define("popover-component", PopoverComponent);
}
